import React, { useMemo } from 'react';
import CustomBadge from 'components/ui/custom-badge';
import { SubmissionResponseDtoStatusEnum } from 'libs/pinnacle-sdk';

interface SubmissionStatusIndicatorProps {
  status: SubmissionResponseDtoStatusEnum;
}

const SubmissionStatusIndicator: React.FC<SubmissionStatusIndicatorProps> = ({
  status,
}) => {
  const config = useMemo(() => {
    switch (status) {
      case SubmissionResponseDtoStatusEnum.Prospect:
        return {
          bg: 'bg-[#DBF6FE]',
          text: 'text-[#16ABDB]',
          label: status,
        };
      case SubmissionResponseDtoStatusEnum.Pending:
        return {
          bg: 'bg-[#FEF0D8]',
          text: 'text-[#E48F00]',
          label: status,
        };
      case SubmissionResponseDtoStatusEnum.Quoted:
        return {
          bg: 'bg-[#EEDEFE]',
          text: 'text-[#8B37F5]',
          label: status,
        };
      case SubmissionResponseDtoStatusEnum.Complete:
        return {
          bg: 'bg-[#D6EBDD]',
          text: 'text-[#329B57]',
          label: status,
        };
      case SubmissionResponseDtoStatusEnum.Declined:
        return {
          bg: 'bg-red-100',
          text: 'text-red-600',
          label: status,
        };
      default:
        return {
          bg: 'bg-gray-100',
          text: 'text-gray-600',
          label: status,
        };
    }
  }, [status]);

  return (
    <CustomBadge
      label={config.label}
      backgroundColor={config.bg}
      textColor={config.text}
    />
  );
};

export default SubmissionStatusIndicator;
